var _mutations, _scopes, _mutationId;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
// src/mutationCache.ts
import { notifyManager } from "./notifyManager.js";
import { Mutation } from "./mutation.js";
import { matchMutation, noop } from "./utils.js";
import { Subscribable } from "./subscribable.js";
var MutationCache = (_mutations = /*#__PURE__*/new WeakMap(), _scopes = /*#__PURE__*/new WeakMap(), _mutationId = /*#__PURE__*/new WeakMap(), class MutationCache extends Subscribable {
  constructor() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    _classPrivateFieldInitSpec(this, _mutations, void 0);
    _classPrivateFieldInitSpec(this, _scopes, void 0);
    _classPrivateFieldInitSpec(this, _mutationId, void 0);
    this.config = config;
    _classPrivateFieldSet(_mutations, this, /* @__PURE__ */new Set());
    _classPrivateFieldSet(_scopes, this, /* @__PURE__ */new Map());
    _classPrivateFieldSet(_mutationId, this, 0);
  }
  build(client, options, state) {
    var _this$mutationId;
    const mutation = new Mutation({
      mutationCache: this,
      mutationId: _classPrivateFieldSet(_mutationId, this, (_this$mutationId = _classPrivateFieldGet(_mutationId, this), ++_this$mutationId)),
      options: client.defaultMutationOptions(options),
      state
    });
    this.add(mutation);
    return mutation;
  }
  add(mutation) {
    _classPrivateFieldGet(_mutations, this).add(mutation);
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      const scopedMutations = _classPrivateFieldGet(_scopes, this).get(scope);
      if (scopedMutations) {
        scopedMutations.push(mutation);
      } else {
        _classPrivateFieldGet(_scopes, this).set(scope, [mutation]);
      }
    }
    this.notify({
      type: "added",
      mutation
    });
  }
  remove(mutation) {
    if (_classPrivateFieldGet(_mutations, this).delete(mutation)) {
      const scope = scopeFor(mutation);
      if (typeof scope === "string") {
        const scopedMutations = _classPrivateFieldGet(_scopes, this).get(scope);
        if (scopedMutations) {
          if (scopedMutations.length > 1) {
            const index = scopedMutations.indexOf(mutation);
            if (index !== -1) {
              scopedMutations.splice(index, 1);
            }
          } else if (scopedMutations[0] === mutation) {
            _classPrivateFieldGet(_scopes, this).delete(scope);
          }
        }
      }
    }
    this.notify({
      type: "removed",
      mutation
    });
  }
  canRun(mutation) {
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      const mutationsWithSameScope = _classPrivateFieldGet(_scopes, this).get(scope);
      const firstPendingMutation = mutationsWithSameScope === null || mutationsWithSameScope === void 0 ? void 0 : mutationsWithSameScope.find(m => m.state.status === "pending");
      return !firstPendingMutation || firstPendingMutation === mutation;
    } else {
      return true;
    }
  }
  runNext(mutation) {
    const scope = scopeFor(mutation);
    if (typeof scope === "string") {
      var _classPrivateFieldGet2, _foundMutation$contin;
      const foundMutation = (_classPrivateFieldGet2 = _classPrivateFieldGet(_scopes, this).get(scope)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.find(m => m !== mutation && m.state.isPaused);
      return (_foundMutation$contin = foundMutation === null || foundMutation === void 0 ? void 0 : foundMutation.continue()) !== null && _foundMutation$contin !== void 0 ? _foundMutation$contin : Promise.resolve();
    } else {
      return Promise.resolve();
    }
  }
  clear() {
    notifyManager.batch(() => {
      _classPrivateFieldGet(_mutations, this).forEach(mutation => {
        this.notify({
          type: "removed",
          mutation
        });
      });
      _classPrivateFieldGet(_mutations, this).clear();
      _classPrivateFieldGet(_scopes, this).clear();
    });
  }
  getAll() {
    return Array.from(_classPrivateFieldGet(_mutations, this));
  }
  find(filters) {
    const defaultedFilters = {
      exact: true,
      ...filters
    };
    return this.getAll().find(mutation => matchMutation(defaultedFilters, mutation));
  }
  findAll() {
    let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this.getAll().filter(mutation => matchMutation(filters, mutation));
  }
  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach(listener => {
        listener(event);
      });
    });
  }
  resumePausedMutations() {
    const pausedMutations = this.getAll().filter(x => x.state.isPaused);
    return notifyManager.batch(() => Promise.all(pausedMutations.map(mutation => mutation.continue().catch(noop))));
  }
});
function scopeFor(mutation) {
  var _mutation$options$sco;
  return (_mutation$options$sco = mutation.options.scope) === null || _mutation$options$sco === void 0 ? void 0 : _mutation$options$sco.id;
}
export { MutationCache };